// extracted by mini-css-extract-plugin
export var menuItem = "B_vk d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "B_vl d_Z d_bz d_bP";
export var menuMainLink = "B_vm d_f0 d_dB";
export var menuLink = "B_vn d_f0 d_dB";
export var icon = "B_p9 d_bC d_bP";
export var divider = "B_vp d_bC d_bP";
export var sublinks = "B_vq";
export var link = "B_mC";
export var Link = "B_tS z_tS z_tb z_tw";